const STORAGE_KEY = "onedpdp_desktop_notifications";

function readStoredPreference() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === "0" || raw === "off" || raw === "false") return false;
    if (raw === "1" || raw === "on" || raw === "true") return true;
  } catch {
    /* ignore */
  }
  // Opt-in: off until the user enables desktop notifications.
  return false;
}

export function isDesktopNotificationSupported() {
  return typeof window !== "undefined" && typeof Notification !== "undefined";
}

export function getDesktopNotificationPermission() {
  if (!isDesktopNotificationSupported()) return "unsupported";
  return Notification.permission;
}

export function isDesktopNotificationEnabled() {
  if (!isDesktopNotificationSupported()) return false;
  if (Notification.permission !== "granted") return false;
  return readStoredPreference();
}

export function persistDesktopNotificationEnabled(enabled) {
  try {
    localStorage.setItem(STORAGE_KEY, enabled ? "1" : "0");
  } catch {
    /* ignore */
  }
}

/**
 * Turn desktop notifications on (requests browser permission if needed)
 * or off. Returns { ok, reason? }.
 */
export async function setDesktopNotificationPreference(enabled) {
  if (!enabled) {
    persistDesktopNotificationEnabled(false);
    return { ok: true, enabled: false };
  }

  if (!isDesktopNotificationSupported()) {
    persistDesktopNotificationEnabled(false);
    return { ok: false, enabled: false, reason: "unsupported" };
  }

  let permission = Notification.permission;
  if (permission === "default") {
    try {
      permission = await Notification.requestPermission();
    } catch {
      persistDesktopNotificationEnabled(false);
      return { ok: false, enabled: false, reason: "unsupported" };
    }
  }

  if (permission !== "granted") {
    persistDesktopNotificationEnabled(false);
    return {
      ok: false,
      enabled: false,
      reason: permission === "denied" ? "denied" : "blocked",
    };
  }

  persistDesktopNotificationEnabled(true);
  return { ok: true, enabled: true };
}
